import NoActiveSubscription from './no-active-subscription';

export default NoActiveSubscription;
